import * as React from 'react';
import Box from '@mui/material/Box';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import IconButton from '@mui/material/IconButton';
import MoreIcon from '@mui/icons-material/MoreVert';
import AppBar from '@mui/material/AppBar';
import Typography from '@mui/material/Typography';
import Toolbar from '@mui/material/Toolbar';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import FacebookIcon from '@mui/icons-material/Facebook';
import AvatarComponent from "./avatarComponent";


type Anchor = 'right';

export default function AppbarComponent() {

    const [state, setState] = React.useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    });

    const toggleDrawer =
        (anchor: Anchor, open: boolean) =>
            (event: React.KeyboardEvent | React.MouseEvent) => {
                if (
                    event &&
                    event.type === 'keydown' &&
                    ((event as React.KeyboardEvent).key === 'Tab' ||
                        (event as React.KeyboardEvent).key === 'Shift')
                ) {
                    return;
                }

                setState({ ...state, [anchor]: open });
            };


    const mobileMenuId = 'primary-search-account-menu-mobile';


    return (
        <div>
            <React.Fragment>
                <Box sx={{ flexGrow: 1 }}>
                    <AppBar position="static"  color="transparent" elevation={0}>
                        <Toolbar>

                            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}></Typography>

                            <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
                                {['A propos', 'Mes créations'].map((text, id) => (
                                    <Button key={'button' + id} href={'#section' + id}>{text}</Button>
                                ))}
                            </Box>

                            <IconButton
                                color="primary"
                                href="https://www.facebook.com/TendreConception"
                                title="Facebook"
                                target="_blank"
                            >
                                <FacebookIcon />
                            </IconButton>
                            <IconButton
                                color="primary"
                                href="mailto:myriam@tendreconception.fr?subject=Demande de renseignements"
                                title="Envoyer un mail"
                            >
                                <EmailOutlinedIcon />
                            </IconButton>
                            <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
                                <IconButton
                                    size="large"
                                    aria-label="show more"
                                    aria-controls={mobileMenuId}
                                    aria-haspopup="true"
                                    onClick={toggleDrawer('right', true)}
                                    color="inherit"
                                >
                                    <MoreIcon />
                                </IconButton>
                            </Box>

                            <AvatarComponent name={"Myriam Druart"} image={"/images/aboutme-2.jpg"} />
                        </Toolbar>
                    </AppBar>
                </Box>
                <SwipeableDrawer
                    anchor={'right'}
                    open={state['right']}
                    onClose={toggleDrawer('right', false)}
                    onOpen={toggleDrawer('right', true)}
                >
                    <Box
                        sx={{ width : 250}}
                        role="presentation"
                        onClick={toggleDrawer('right', false)}
                        onKeyDown={toggleDrawer('right', false)}
                    >
                        <List>
                            {['A propos', 'Créations'].map((text, index) => (
                                <ListItem button key={'tata' + index} component="a" href={'#section' + index}>
                                    <ListItemIcon>
                                        {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
                                    </ListItemIcon>
                                    <ListItemText primary={text} />
                                </ListItem>
                            ))}
                        </List>
                    </Box>
                </SwipeableDrawer>
            </React.Fragment>
        </div>
    );
}
